var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div" },
    [
      _c("dd-header", { attrs: { isMenuView: false } }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { attrs: { id: "content" } }, [
          _c("div", [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "detail_btn2 btn_pos_center",
                on: { click: _vm.goLogin }
              },
              [_vm._v("ログイン画面へ戻る 〉〉")]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h2", [_vm._v("パスワードリセット送信完了")]),
      _vm._v(" "),
      _c("div", [
        _vm._v("\n            パスワードリセットメールを自動送信しました。"),
        _c("br"),
        _vm._v(
          "\n            メールに記載されたURLよりパスワードリセットにお進みください。\n          "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n            ※受信制限をされている方は、「"),
        _c("span", { staticClass: "pickup" }, [_vm._v("@domans.co.jp")]),
        _vm._v("」からのメールを受信許可に設定してください"),
        _c("br"),
        _vm._v(
          "\n            ※メールアドレスを間違えて入力してしまった場合は、再度仮登録手続きを行ってください。\n          "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ad2c162c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad2c162c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcPasswordResetConfirm.vue
// module id = null
// module chunks = 